module.exports = __webpack_public_path__ + "static/media/frigidaire-applicances.301fe76e.webp";